import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import MDEditor from '@uiw/react-md-editor';
import { getQuestionScore, getStudentScore, getTimeToComplete, getTotalScore } from '../../../util/mission.js';
import ReferencePopupWindow from './ReferencePopupWindow.js';

const dragAndDropWidth = 90
const dragAndDropHeight = 90

function Component(props) {
    const mission = props.mission || {}
    const [showReferencePopup, setshowReferencePopup] = useState(false)
    const isPublic=props.isPublic||false

    return (
        <div className='relative h-full min-w-[600px] flex-1 bg-[#F2F2F2] flex-col flex text-[16px] text-[black]' style={{ overflowY: "auto" }}>
            <div className='w-full flex flex-row items-center justify-start items-center gap-[8px] flex-wrap p-[16px] font-[700]'>
                <div className='flex-1 min-w-[300px]'>閲讀任務名稱: {mission?.name}</div>
                {isPublic || <div className='flex-1 min-w-[300px]'>學校名稱: {mission?.school?.name}</div>}
                {isPublic ||<div className='flex-1 min-w-[300px]'>學生姓名: {mission?.student?.name}</div>}
                {isPublic ||<div className='flex-1 min-w-[300px]'>學生班級: {mission?.student?.class}</div>}
                {isPublic ||<div className='flex-1 min-w-[300px]'>學生性別: {mission?.student?.gender}</div>}
                <div className='flex-1 min-w-[300px]'>開始時間: {mission?.startTime ? new Date(mission.startTime).toLocaleString() : ''}</div>
                <div className='flex-1 min-w-[300px]'>完成時間: {mission?.finishTime ? new Date(mission.finishTime).toLocaleString() : ''}</div>
                <div className='flex-1 min-w-[300px]'>回答時間（分:秒）: {getTimeToComplete(mission)}</div>
                <div className='flex-1 min-w-[300px]'>任務狀態: {mission?.status}</div>
                <div className='flex-1 min-w-[300px]'>分數: {getStudentScore(mission?.questions)}/{getTotalScore(mission?.questions)}</div>
                {isPublic ||<div className='flex-[2] min-w-[300px]'>老師評語: {mission?.remarks||''}</div>}
            </div>

            <div className='w-full p-[16px]'>
                <div className='w-full flex flex-col border-[1px] border-[#000]'>
                    <div className='w-full flex p-[4px] border-[1px] border-[#000]'>
                        閱讀成績單
                    </div>
                    <div className='w-full flex p-[4px] border-[1px] border-[#000]'>
                        總分: {getStudentScore(mission?.questions)}/{getTotalScore(mission?.questions)}
                    </div>
                    <div className='w-full flex flex-row itesm-stretch justify-start'>
                        <div className='border-[1px] border-[#000] w-[50px] p-[4px]'>題號</div>
                        <div className='border-[1px] border-[#000] p-[4px]' style={{ width: 'calc( (100% - 200px) /3 )' }}>問題</div>
                        <div className='border-[1px] border-[#000] p-[4px]' style={{ width: '150px' }}>你的得分/題目總分</div>
                        <div className='border-[1px] border-[#000] p-[4px]' style={{ width: 'calc( (100% - 200px) /3 )' }}>你的答案</div>
                        <div className='border-[1px] border-[#000] p-[4px]' style={{ width: 'calc( (100% - 200px) /3 )' }}>標準答案</div>
                    </div>
                    {mission?.questions?.map((question, index) =>
                        ['老師導語','提示語'].includes(question?.type) ? null :
                        <div key={question.id || index} className='w-full flex flex-row itesm-stretch justify-start'>
                            <div className='border-[1px] border-[#000] w-[50px] p-[4px]'>
                                {mission?.questions?.filter((q, qi) => qi <= index && ['選擇網頁', '選擇題', '短句作答題', '選擇題 + 短句作答題', '表格問題', '拖放式問題', '拉選題'].includes(q.type)).length}
                            </div>
                            <div className='border-[1px] border-[#000] p-[4px]  flex flex-col' style={{ width: 'calc( (100% - 200px) /3 )' }}>
                                {<MDEditor.Markdown source={
                                    ['短句作答題'].includes(question?.type)
                                        ? (question.questionShortanswer || '')
                                        : ['選擇網頁'].includes(question?.type)
                                            ? (question.dialog || '')
                                            : (question?.question || '')
                                } style={{ whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent" }} />}
                                {['選擇網頁', '拉選題','選擇題', '選擇題 + 短句作答題'].includes(question.type) &&
                                    <div className='w-full mt-[16px] flex flex-col items-start gap-[4px]'>
                                        {question.options?.map((option, optionIndex) => (
                                            <div key={optionIndex} className='flex flex-row gap-[8px] items-center'>
                                                {option.text}
                                            </div>
                                        ))}
                                    </div>
                                }


                               
                                {['選擇題 + 短句作答題'].includes(question?.type) &&
                                    <MDEditor.Markdown source={(question.questionShortanswer || '')} style={{ whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent", marginTop: 24 }} />
                                }
                            </div>
                            <div className='border-[1px] border-[#000] p-[4px]' style={{ width: '150px' }}>{getQuestionScore(question)}/{question.score}</div>

                            {/*student answers */}
                            <div className='border-[1px] border-[#000] p-[4px]' style={{ width: 'calc( (100% - 200px) /3 )' }}>
                                {['選擇網頁', '拉選題','選擇題', '選擇題 + 短句作答題'].includes(question.type) &&
                                    <div className='w-full flex flex-col items-start gap-[16px]'>
                                        {question?.options.filter(o => o.isSelected)?.map((option, optionIndex) =>
                                            <div key={optionIndex} className='flex flex-row gap-[8px] items-center'>
                                                • {option.text}
                                            </div>
                                        )}
                                    </div>
                                }
                        

                                {['短句作答題', '選擇題 + 短句作答題'].includes(question?.type) &&
                                    <div className='w-full flex flex-col items-start gap-[16px]'>
                                        {question?.answer || ''}
                                    </div>
                                }
                                {['短句作答題', '選擇題 + 短句作答題'].includes(question?.type) && question.hasTwoAnswers &&
                                    <div className='w-full flex flex-col items-start gap-[16px]'>
                                        {question?.answer2 || ''}
                                    </div>
                                }
                            </div>
                            {/* end of student answers */}

                            {/* model answers */}
                            <div className='border-[1px] border-[#000] p-[4px]' style={{ width: 'calc( (100% - 200px) /3 )' }}>
                                {['選擇網頁', '拉選題','選擇題', '選擇題 + 短句作答題'].includes(question?.type) && question?.options?.filter(i => i.correct).length > 0 &&
                                    <div className='w-full flex flex-col items-start gap-[16px]'>
                                        {question?.options?.filter(i => i.correct)?.map((option, optionIndex) =>
                                            option.correct ?
                                                <div key={optionIndex} className='flex flex-row gap-[8px] items-center'>
                                                    • {option.text}<br />
                                                </div>
                                                : null
                                        )}
                                    </div>
                                }
                            
                             
                                <div className={``} style={{ textAlign: 'left' }}>
                                    <div style={{ whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent" }}>
                                        <div className='inline' dangerouslySetInnerHTML={{ __html: (question?.answers?.popups?.[0] ? question?.answers?.text?.slice(0, question?.answers?.popups?.[0]?.start) : question?.answers?.text) || '' }} />
                                        {question?.answers?.popups?.sort((a, b) => (a.start > b.start) ? 1 : (a.start < b.start) ? -1 : 0
                                        )?.map((r, ri) =>
                                            <div className='inline' key={ri}>
                                                <div className='inline text-[blue] cursor-pointer underline' onClick={() => {
                                                    setshowReferencePopup(r)
                                                }} dangerouslySetInnerHTML={{ __html: question?.answers?.text.slice(r.start, r.end) }} />
                                                <div className='inline' dangerouslySetInnerHTML={{
                                                    __html:
                                                        question?.answers.popups?.[ri + 1] ?
                                                            question?.answers?.text.slice(r.end, question?.answers.popups?.[ri + 1].start)
                                                            : question?.answers?.text.slice(r.end)
                                                }} />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {/* end of model answers */}
                        </div>
                    )}
                </div>
            </div>

            {showReferencePopup && <ReferencePopupWindow
                data={showReferencePopup}
                page={mission.pages?.filter(p => p.id === showReferencePopup?.page_id)?.[0]}
                onClose={() => {
                    setshowReferencePopup(false)
                }}
            />}

        </div>
    )

}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
